module.exports = __webpack_public_path__ + "img/青逸植发.75bda5e.png";